/* モーダルの表示非表示をする関数
 *
 * @params {Array[string]} openClassNames クリックでmodalClassNameにクラス名activeを付与するためのトリガーのクラス名
 * @params {Array[string]} closeClassNames クリックでmodalClassNameにクラス名activeを削除するためのトリガーのクラス名
 * @params {string} modalClassName クラス名activeをトグルするモーダルのクラス名
*/

const toggleModal = (openClassName, closeClassNames, modalClassName) => {
  const elementsNodes = {
    openTriggers: document.querySelectorAll(`.${openClassName}`)
  };

  const $elements = {
    openTriggers: Array.prototype.slice.call(elementsNodes.openTriggers, 0),
    closeTriggers: closeClassNames.map(x => document.querySelector(`.${x}`)),
    modalBody: document.getElementsByClassName(modalClassName)[0]
  };

  function toggleModalActive (isActive) {
    if (isActive) {
      $elements.modalBody.classList.add('active');
    } else {
      $elements.modalBody.classList.remove('active');
    }
  }

  function addEvents () {
    if ($elements.openTriggers[0] !== null) {
      $elements.openTriggers.forEach(el => {
        el.addEventListener('click', e => {
          toggleModalActive(true);
          e.preventDefault();
        });
      });
    }
    $elements.closeTriggers.forEach(el => {
      el.addEventListener('click', e => {
        if ($elements.closeTriggers.indexOf(e.target) > -1) {
          toggleModalActive(false);
          e.preventDefault();
        }
      });
    });
  }

  function init () {
    if ($elements.modalBody !== null && $elements.openTriggers.length > 0) {
      addEvents();
    }
  }

  init();
};

window.addEventListener('DOMContentLoaded', () => {
  toggleModal('js-modal-login-open', ['js-modal-login-overlay', 'js-modal-login-close'], 'js-modal-login-overlay');
});
